import { Injectable } from '@angular/core';
import { classToPlain, plainToClass } from 'class-transformer';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RestService } from '../../service/rest.service';
import { SetOfFilters } from '../model/set-of-filters';

@Injectable()
export class SetsOfFiltersService extends RestService {

  fetchSetsOfFilters(dataType: string): Observable<SetOfFilters[]> {
    return this.getRequestWithSimpleResponse<SetOfFilters[]>(`api/setOfFilters/${dataType}/fetch`)
      .pipe(map(setsOfFilters => plainToClass(SetOfFilters, setsOfFilters)));
  }

  saveSetOfFilters(setOfFilters: SetOfFilters): Observable<SetOfFilters> {
    return this.postAndExtractSingle<SetOfFilters>(SetOfFilters, 'api/setOfFilters/save', classToPlain<SetOfFilters>(setOfFilters));
  }

  deleteSetOfFilters(setOfFiltersId: number): Observable<any> {
    return this.deleteAndExtractSingle<SetOfFilters>(SetOfFilters, `api/setOfFilters/${setOfFiltersId}`);
  }
}
